import { buttonClasses } from '@mui/material/Button';
import { listClasses } from '@mui/material/List';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { paperClasses } from '@mui/material/Paper';
import { tablePaginationClasses } from '@mui/material/TablePagination';
import { Theme, alpha } from '@mui/material/styles';
//
import { paper } from '../../css';

// ----------------------------------------------------------------------

export default function DataGrid(theme: Theme) {
  const paperStyles = paper({ theme, dropdown: true });
  const headerBackground = alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.18 : 0.06);

  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          borderWidth: 0,
          [`& .${tablePaginationClasses.root}`]: {
            borderTop: 0,
          },
          [`& .${tablePaginationClasses.toolbar}`]: {
            height: 'auto',
          },
          '& ::-webkit-scrollbar': {
            transition: '0.7s fade-in',
            visibility: 'hidden',
            height: '7px',
          },
          '& ::-webkit-scrollbar-thumb': {
            transition: '0.7s fade-in',
            visibility: 'hidden',
            borderRadius: '15px',
            backgroundColor: '#e3e3e3',
          },
          '&:hover': {
            '& ::-webkit-scrollbar': {
              visibility: 'visible',
              height: '7px',
            },
            '& ::-webkit-scrollbar-thumb': {
              visibility: 'visible',
              borderRadius: '15px',
              backgroundColor: '#e3e3e3',
            },
          },
          '& .MuiDataGrid-main': {
            '& div:nth-last-child(1)[style="position: absolute; pointer-events: none; color: rgba(130, 130, 130, 0.62); z-index: 100000; width: 100%; text-align: center; bottom: 50%; right: 0px; letter-spacing: 5px; font-size: 24px;"]':
              {
                display: 'none',
              },
          },
          '& .flaggedRow.MuiDataGrid-row': {
            position: 'relative',
            '&:before': {
              display: 'none',
              position: 'absolute',
              content: '""',
              width: 0,
              height: 0,
              borderLeft: '0px solid transparent',
              borderRight: '20px solid transparent',
              borderTop: `20px solid ${alpha(theme.palette.warning.main, 1)}`,
            },
          },
          '.MuiDataGrid-pinnedColumns': {
            '& .flaggedRow.MuiDataGrid-row': {
              position: 'relative',
              '&:before': {
                display: 'none',
              },
              '& .MuiDataGrid-cellCheckbox': {
                '&:before': {
                  position: 'absolute',
                  content: '""',
                  top: 0,
                  left: 0,
                  width: 0,
                  height: 0,
                  borderLeft: '0px solid transparent',
                  borderRight: '20px solid transparent',
                  borderTop: `20px solid ${alpha(theme.palette.warning.main, 1)}`,
                },
              },
            },
          },
          '.MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          '.MuiDataGrid-footerContainer': {
            backgroundColor: 'transparent !important',
          },
          '&.MuiDataGrid-root': {
            '--DataGrid-containerBackground': `${headerBackground} !important`,
          },
        },
        cell: {
          border: `1px solid ${alpha(theme.palette.grey[500], 0.16)}`,
          borderRight: 0,
          borderTop: 0,
          color: theme.palette.text.secondary,
          fontWeight: 400,
          '&:focus': {
            outline: 'none',
          },
          '&:focus-within': {
            outline: 'none',
          },
        },
        selectedRowCount: {
          whiteSpace: 'nowrap',
        },
        columnSeparator: {
          color: theme.palette.divider,
        },
        toolbarContainer: {
          padding: theme.spacing(2),
          borderBottom: `1px dashed ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.neutral,
        },
        paper: {
          ...paperStyles,
          padding: 0,
        },
        menu: {
          [`& .${paperClasses.root}`]: {
            ...paperStyles,
          },
          [`& .${listClasses.root}`]: {
            padding: 0,
            [`& .${listItemIconClasses.root}`]: {
              minWidth: 0,
              marginRight: theme.spacing(2),
            },
          },
        },
        columnHeaders: {
          padding: 0,
          borderRadius: 0,
          color: theme.palette.text.primary,
          backgroundColor: `${headerBackground} !important`,
          outline: 'none',
          outlineWidth: '0px',
          '&:focus': {
            outline: 'none',
            outlineWidth: '0px',
          },
          '&:focus-within': {
            outline: 'none !important',
            outlineWidth: '0px',
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            fontWeight: '600 !important',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: theme.palette.text.primary,
          },
        },
        panelHeader: {
          padding: theme.spacing(2),
        },
        panelFooter: {
          padding: theme.spacing(2),
          justifyContent: 'flex-end',
          [`& .${buttonClasses.root}`]: {
            '&:first-of-type': {
              border: `solid 1px ${alpha(theme.palette.grey[500], 0.24)}`,
            },
            '&:last-of-type': {
              marginLeft: theme.spacing(1.5),
              color: theme.palette.background.paper,
              backgroundColor: theme.palette.text.primary,
            },
          },
        },
        filterForm: {
          padding: theme.spacing(2),
        },
        filterFormValueInput: {
          marginLeft: theme.spacing(2),
        },
        filterFormColumnInput: {
          marginLeft: theme.spacing(2),
        },
        filterFormOperatorInput: {
          marginLeft: theme.spacing(2),
        },
      },
    },
  };
}
